import moment from "moment";

const dateKeys = new Set([
  "lower",
  "upper",
  "change_date",
  "birth_date",
  "created",
  "modified"
]);

function reviver(key, value) {
  if (
    typeof value === "string" &&
    !/^\d{4}$/.test(value) &&
    dateKeys.has(key)
  ) {
    const date = moment(value, ["YYYY-MM-DD", moment.ISO_8601], true);
    if (date.isValid()) {
      return date;
    }
  }

  return value;
}

export const parseJSON = text => JSON.parse(text, reviver);

export function dateFmt(date) {
  return date ? date.format() : "-";
}

export function durationFmt(start, end) {
  const today = moment();
  let duration = "-";

  if (start && start.isSameOrBefore(today)) {
    if (end) {
      duration = start.from(end, true);
    } else {
      duration = start.fromNow(true);
    }
  }
  return duration;
}

export function startDateInfo(start) {
  const today = moment();
  return (
    start &&
    (start.isSameOrBefore(today)
      ? `Desde ${start.format()}`
      : `Começa em ${start.format()}`)
  );
}
